// core/api/useTablePromotion.ts

import axios from "axios";
import { API_BASE_PATH } from "../../environment";
import { toast } from "react-toastify";

const PROMOTION_BASE_URL = API_BASE_PATH;

// 🌟 1. Define the response shape
export interface TablePromotion {
  employee_id: string;
  username: string;
  designation_from: string;
  designation_to: string;
  promotion_date: string; // ISO date string e.g., "2025-04-03"
}

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

// 🌟 2. Fetch function
export const fetchTablePromotions = async (
  token: string | null
): Promise<TablePromotion[]> => {
  if (!token) {
    const msg = "Authentication token is missing";
    toast.error(msg);
    throw new Error(msg);
  }

  try {
    const response = await axios.get<TablePromotion[]>(
      `${PROMOTION_BASE_URL}/promotions/get_all/promotion/table`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    console.error("Error fetching table promotions:", msg);
    throw error;
  }
};
